import { downloadFile } from '@mi-front/core';
import DownloadIcon from '@mui/icons-material/Download';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export function DownloadAudiogramBtn({ url }: { url: string }) {
  return (
    <Button
      color="inherit"
      variant="outlined"
      size="small"
      onClick={() => {
        downloadFile(`${url}&response-content-disposition=attachment;`, false);
      }}
      startIcon={<DownloadIcon />}
    >
      <FormattedMessage id="common.download" defaultMessage="Descargar" />
    </Button>
  );
}
